export default "__VITE_ASSET__DiFA9FX___"